var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkspaceTeamIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.498,
    height: 30,
    viewBox: "0 0 52.498 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29221",
    "data-name": "Group 29221",
    transform: "translate(19632.25 11558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "users",
    d: "M67.881-773.432v-5.625a7.544,7.544,0,0,0-1.148-3.961,10.129,10.129,0,0,0-3.258-3.258,23.651,23.651,0,0,1,4.5.961,23.46,23.46,0,0,1,3.937,1.664,8.3,8.3,0,0,1,2.578,2.086,4,4,0,0,1,.891,2.508v5.625Z",
    transform: "translate(-19655.133 -10754.569)",
    fill: "#fa9c2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "users-2",
    "data-name": "users",
    d: "M69.025-792.5a7.222,7.222,0,0,1-2.2,5.3,7.222,7.222,0,0,1-5.3,2.2,9.363,9.363,0,0,1-1.312-.117,11.476,11.476,0,0,1-1.312-.258,11.149,11.149,0,0,0,1.945-3.328,10.808,10.808,0,0,0,.68-3.8,10.808,10.808,0,0,0-.68-3.8,11.15,11.15,0,0,0-1.945-3.328,5.7,5.7,0,0,1,1.312-.3,12.311,12.311,0,0,1,1.312-.07,7.222,7.222,0,0,1,5.3,2.2A7.222,7.222,0,0,1,69.025-792.5Z",
    transform: "translate(-19656.275 -10758)",
    fill: "#ffca8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "users-3",
    "data-name": "users",
    d: "M79-773.375v-5.25a5.492,5.492,0,0,0-.82-2.93A5.468,5.468,0,0,0,76-783.594a27.836,27.836,0,0,0-5.906-2.18A25.8,25.8,0,0,0,64-786.5a25.8,25.8,0,0,0-6.094.727A27.835,27.835,0,0,0,52-783.594a5.468,5.468,0,0,0-2.18,2.039,5.492,5.492,0,0,0-.82,2.93v5.25Z",
    transform: "translate(-19670 -10754.625)",
    fill: "#fa9c2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "users-4",
    "data-name": "users",
    d: "M62.5-785a7.222,7.222,0,0,0,5.3-2.2,7.222,7.222,0,0,0,2.2-5.3,7.222,7.222,0,0,0-2.2-5.3,7.222,7.222,0,0,0-5.3-2.2,7.222,7.222,0,0,0-5.3,2.2,7.222,7.222,0,0,0-2.2,5.3,7.222,7.222,0,0,0,2.2,5.3A7.222,7.222,0,0,0,62.5-785Z",
    transform: "translate(-19668.5 -10758)",
    fill: "#ffca8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "users-5",
    "data-name": "users",
    d: "M46-792.5a7.222,7.222,0,0,0,2.2,5.3,7.222,7.222,0,0,0,5.3,2.2,9.363,9.363,0,0,0,1.312-.117,11.476,11.476,0,0,0,1.312-.258A11.149,11.149,0,0,1,54.18-788.7a10.808,10.808,0,0,1-.68-3.8,10.808,10.808,0,0,1,.68-3.8,11.15,11.15,0,0,1,1.945-3.328,5.7,5.7,0,0,0-1.312-.3A12.311,12.311,0,0,0,53.5-800a7.222,7.222,0,0,0-5.3,2.2A7.222,7.222,0,0,0,46-792.5Z",
    transform: "translate(-19670.75 -10758)",
    fill: "#ffca8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "users-6",
    "data-name": "users",
    d: "M47.5-773.432v-5.625a7.544,7.544,0,0,1,1.148-3.961,10.129,10.129,0,0,1,3.258-3.258,23.651,23.651,0,0,0-4.5.961,23.46,23.46,0,0,0-3.937,1.664,8.305,8.305,0,0,0-2.578,2.086A4,4,0,0,0,40-779.056v5.625Z",
    transform: "translate(-19672.25 -10754.569)",
    fill: "#fa9c2b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspaceTeamIcon);
export default __webpack_public_path__ + "static/media/workspace_team_icon.74d19b1120c1984a9cf01b2ba01f016f.svg";
export { ForwardRef as ReactComponent };